import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-statistic-lavage-help',
  templateUrl: './statistic-lavage-help.component.html',
  styleUrls: ['./statistic-lavage-help.component.scss']
})
export class StatisticLavageHelpComponent {
  constructor(
    private dialogRef: MatDialogRef<StatisticLavageHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  refuse() {
    this.dialogRef.close(false);
  }
}